import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { InputLabel, MenuItem, Select, FormControl } from "@material-ui/core";
import { Toggle } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";
import { setApiKey } from "react-geocode";
import TestConnection from "../TestConnection";

function ConfigurationApi({ handleShowTab, formik, ...props }) {
  const [appKey, SetAppkey] = useState(true);
  const [apiKey, setApiKey] = useState(false);

  const handlesave = () => {
    formik.handleSubmit();
  };

  const testConnectionObj = { 
      "base_url": formik.values.environment === "STAGING" ? formik.values.staging_config.base_url : formik.values.production_config.base_url,
      "app_key": formik.values.environment === "STAGING" ? formik.values.staging_config.app_key : formik.values.production_config.app_key,
      "app_secret": formik.values.environment === "STAGING" ? formik.values.staging_config.app_secret : formik.values.production_config.app_secret ,
      "access_token": formik.values.environment === "STAGING" ? formik.values.staging_config.access_token : formik.values.production_config.access_token,
  }

  const onSuccessSetRunningStatus = (data) => {
    formik.setFieldValue('runningStatus',"1")
  }

  return (
    <div>
      <div className="row checkbox-bank-account justify-content-start mb-4">
        <div className="col-4 col-sm-4 col-md-3">
          <label className="enRadioWithText small">
            <span className="f12-500">Sandbox</span>
            <input
              id="production"
              type="radio"
              name="environment"
              value="STAGING"
              checked={formik.values.environment === "STAGING"}
              onChange={formik.handleChange}
            />
            <span className="checkmark"></span>
          </label>
        </div>
        <div className="col-4 col-sm-4 col-md-3">
          <label className="enRadioWithText small">
            <span className="f12-500">Production</span>
            <input
              id="production"
              type="radio"
              name="environment"
              value="PRODUCTION"
              checked={formik.values.environment === "PRODUCTION"}
              onChange={formik.handleChange}
            />
            <span className="checkmark"></span>
          </label>
        </div>
      </div>
      <div className="acesskeys">
        <div className="my-2">
          <div className="d-flex">
            <Toggle
              toggleFunction={() => SetAppkey(!appKey)}
              className="my-3"
              checked={appKey}
            />
            <div className="f14-700 mx-3">
              app_key , app_secret , Acess Token{" "}
            </div>
          </div>
          {appKey && (
            <>
              <div>
                <div className="col-12 my-2">
                  <div className="col-4">
                    <div className="col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12">
                      <div className="f14-500 my-2">app_key</div>
                      <NewInputText
                        displayLabel={true}
                        controlId="appKey"
                        name={formik.values.environment === "STAGING" ? "staging_config.app_key" : "production_config.app_key"}
                        inputType="text"
                        required="required"
                        onChange={formik.handleChange}
                        value={formik.values.environment === "STAGING" ? formik.values.staging_config.app_key : formik.values.production_config.app_key }
                      />
                    </div>
                    <div className="col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12">
                      <div className="f14-500 my-2">app_secret</div>
                      <NewInputText
                        displayLabel={true}
                        controlId="appsecret"
                        name={formik.values.environment === "STAGING" ? "staging_config.app_secret" : "production_config.app_secret"}
                        inputType="text"
                        required="required"
                        onChange={formik.handleChange}
                        value={formik.values.environment === "STAGING" ? formik.values.staging_config.app_secret : formik.values.production_config.app_secret }
                      />
                    </div>
                    <div className="col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12">
                      <div className="f14-500 my-2">Access Token</div>
                      <NewInputText
                        displayLabel={true}
                        controlId="accessToken"
                        name={formik.values.environment === "STAGING" ? "staging_config.access_token" : "production_config.access_token"}
                        inputType="text"
                      
                        required="required"
                        onChange={formik.handleChange}
                        value={formik.values.environment === "STAGING" ? formik.values.staging_config.access_token : formik.values.production_config.access_token }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="my-2">
          <div className="d-flex">
            <Toggle
              toggleFunction={() => SetAppkey(!appKey)}
              className="my-3"
              checked={!appKey}
            />
            <div className="f14-700 mx-3">API key and Password </div>
          </div>
          {!appKey && (
            <>
              <div>
                <div className="col-12 my-2">
                  <div className="col-4">
                    <div className="col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12">
                      <div className="f14-500 my-2">API Key</div>
                      <NewInputText
                        displayLabel={true}
                        controlId="apiKey"
                        name={formik.values.environment === "STAGING" ? "staging_config.api_key" : "production_config.api_key"}
                        inputType="text"
                        maxLength="10"
                        onChange={formik.handleChange}
                        value={formik.values.environment === "STAGING" ? formik.values.staging_config.api_key : formik.values.production_config.api_key }
                      />
                    </div>
                    <div className="col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12">
                      <div className="f14-500 my-2">Password</div>
                      <NewInputText
                        displayLabel={true}
                        extraClass="mb-4"
                        name={formik.values.environment === "STAGING" ? "staging_config.password" : "production_config.password"}
                        controlId="password"
                        inputType="text"
                        onChange={formik.handleChange}
                        value={formik.values.environment === "STAGING" ? formik.values.staging_config.password : formik.values.production_config.password }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="my-2">
          <div className="col-4 col-sm-6 col-md-4">
            <div className="f14-500 mb-2 mt-3">Base URL</div>
            <NewInputText
              displayLabel={true}
              extraClass="mb-4"
              controlId="baseUrl"
              name={formik.values.environment === "STAGING" ? "staging_config.base_url" : "production_config.base_url"}
              inputType="text"
              required="required"
              onChange={formik.handleChange}
              value={formik.values.environment === "STAGING" ? formik.values.staging_config.base_url : formik.values.production_config.base_url }
            />
          </div>
          <div className="col-4 col-sm-6 col-md-4">
            <div className="f14-500 mb-2 mt-3">Save order URL</div>
            <NewInputText
              displayLabel={true}
              extraClass="mb-4"
              controlId="saveOrder"
              name={formik.values.environment === "STAGING" ? "staging_config.save_order_url" : "production_config.save_order_url"}
              inputType="text"
              required="required"
              onChange={formik.handleChange}
              value={formik.values.environment === "STAGING" ? formik.values.staging_config.save_order_url : formik.values.production_config.save_order_url }
            />
          </div>
          <div className="col-4 col-sm-6 col-md-4">
            <div className="f14-500 mb-2 mt-3">Update order URL</div>
            <NewInputText
              displayLabel={true}
              extraClass="mb-4"
              controlId="updateOrder"
              name={formik.values.environment === "STAGING" ? "staging_config.update_order_url" : "production_config.update_order_url"}
              inputType="text"
              required="required"
              onChange={formik.handleChange}
              value={formik.values.environment === "STAGING" ? formik.values.staging_config.update_order_url : formik.values.production_config.update_order_url }
            />
          </div>
          <div className="col-4 col-sm-6 col-md-4">
            <div className="f14-500 mb-2 mt-3">Rider info URL</div>
            <NewInputText
              displayLabel={true}
              extraClass="mb-4"
              controlId="riderInfo"
              name={formik.values.environment === "STAGING" ? "staging_config.rider_update_url" : "production_config.rider_update_url"}
              inputType="text"
              required="required"
              onChange={formik.handleChange}
              value={formik.values.environment === "STAGING" ? formik.values.staging_config.rider_update_url : formik.values.production_config.rider_update_url }
            />
          </div>
        </div>
      </div>
      <div>
        {/* <TestConnection formData = {testConnectionObj} onSuccess={onSuccessSetRunningStatus}/> */}
      </div>
      <div className="py-4 d-flex align-items-center">
        <Button
          variant="outline-secondary"
          className="btn-lg mr-4 px-5 btn150px"
          onClick={(e) => handleShowTab("1")}
        >
          Back
        </Button>
        <Button
          variant="danger"
          className="btn-lg px-5 btn150px"
          //type="submit"
          onClick={(e) => handlesave()}
        >
          Save
        </Button>
      </div>
    </div>
  );
}

export default ConfigurationApi;
